/**
 * Common functionality for the Person / Avatar components
 */
import { TABLE_TYPES, USER_CONNECTIONS_STATUSES } from "@/helpers/constants";
import VideoChatPermissionsMixin from "@/components/DigitalEvent/mixins/Permissions/VideoChatPermissionsMixin.js";

export default {
  mixins: [VideoChatPermissionsMixin],
  props: {
    options: {
      type: Object,
      required: false,
      default: () => {}
    },
    person: {
      type: Object,
      required: false,
      default: () => {}
    },
    connected: {
      type: Boolean
    }
  },
  computed: {
    userConnectionsStatuses() {
      return USER_CONNECTIONS_STATUSES;
    },
    photo() {
      return this.person.profile ? this.person.profile.photo : "";
    },
    company() {
      return this.person.profile ? this.person.profile.company : "";
    },
    jobtitle() {
      return this.person.profile ? this.person.profile.jobTitle : "";
    },
    initials() {
      return `${this.firstName[0]}${this.lastName[0]}`;
    },
    firstName() {
      if (this.person) {
        if (this.person.profile && this.person.profile.firstName) {
          return this.person.profile.firstName;
        } else {
          return this.person.firstName;
        }
      }
      return "";
    },
    lastName() {
      if (this.person) {
        if (this.person.profile && this.person.profile.lastName) {
          return this.person.profile.lastName;
        } else {
          return this.person.lastName;
        }
      }
      return "";
    },
    fullname() {
      return this.getFullName();
    },
    facebook() {
      return this.person.profile ? this.person.profile.facebook : "";
    },
    linkedin() {
      return this.person.profile ? this.person.profile.linkedin : "";
    },
    twitter() {
      return this.person.profile ? this.person.profile.twitter : "";
    },
    backgroundImage() {
      return this.photo ? "url(" + this.photo + ")" : "";
    },
    online() {
      return this.person.isOnline;
    },
    table() {
      return this.$store.getters["tables/tableByUser"](this.person);
    },
    /**
     * Permissions for the <person> object
     * @returns {Object}
     */
    permissions() {
      let canNetwork = this.table ? this.table.TABLE_TYPE !== TABLE_TYPES.PUBLIC_GALLERY : false;
      return {
        canNetwork: canNetwork,
        canUseVideo:
          canNetwork &&
          this.canUserSendVideoCallInvites(this.person) &&
          this.$store.getters["users/canUserAcceptVideoCallInvites"](this.person),
        canUserSendVideoCallInvites: canNetwork && this.canUserSendVideoCallInvites(this.person),
        canAcceptVideoCallInvites:
          canNetwork && this.$store.getters["users/canUserAcceptVideoCallInvites"](this.person),
        canPrivateChat: canNetwork
      };
    }
  },
  methods: {
    /**
     * Check that userUUID exist in userConnections with current statuses
     * @param userUUID {String}
     * @param status {String}
     * @return {boolean}
     */
    isInConnections(userUUID, status) {
      return Boolean(
        this.$store.state.users.userConnections.find(connection => {
          return connection.targetUserUUID === userUUID && (status ? status === connection.connectionStatus : true);
        })
      );
    },

    /**
     * Get user's full name
     *  if user set profile - user's name will be combined from profile info
     *  In the other way full name will be combined from connection info (person object directly)
     * @param showIsMe {Boolean} if this flag set to True will be returned simple text 'Me'
     * @return {string}
     */
    getFullName(showIsMe) {
      if (showIsMe && this.isCurrentUser(this.person)) {
        return "Me";
      }
      return `${this.firstName} ${this.lastName}`;
    },

    /**
     * Scroll to the user's table in the UI
     * @param tableUUID
     */
    scrollToTable(tableUUID) {
      this.$scrollTo("#TABLE-" + tableUUID);
    }
  }
};
